import React, { ChangeEvent, FC, useCallback, useEffect, useState } from 'react'
import { Header } from '../../components/header'
import { Steps } from '../../components/steps'

export type Props = {
  approvedData: ApprovedData
  goNextStep: (activeThickness: string, length: string, width: string) => void
  goBackStep: () => void
}

export type ApprovedData = {
  email: string
  material: string
  design: string
}

export const Step_3: FC<Props> = ({ approvedData, goNextStep, goBackStep }) => {
  const [activeMaterial] = useState<string>(approvedData.material)
  const [activeThickness, setThickness] = useState<string>('')
  const [length, setLength] = useState<string>('')
  const [width, setWidth] = useState<string>('')
  const [qty, setQty] = useState<string>('')

  const [showButton, setButton] = useState<boolean>(false)

  const dataItem = document.getElementById('custom-sizes-step-3')
  const data = dataItem !== null ? JSON.parse(dataItem.innerText) : null

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (activeMaterial === 'Wood') {
      if (length !== '' && width !== '' && qty !== '') {
        setButton(true)
      } else {
        setButton(false)
      }
    } else {
      if (
        activeThickness !== '' &&
        length !== '' &&
        width !== '' &&
        qty !== ''
      ) {
        setButton(true)
      } else {
        setButton(false)
      }
    }
  }, [activeThickness, length, width, qty])

  if (data == null) {
    return null
  }

  function changeThickness(e: string) {
    setThickness(e)
  }

  function onLength(e: ChangeEvent<HTMLInputElement>) {
    setLength(e.target.value)
  }

  function onWidth(e: ChangeEvent<HTMLInputElement>) {
    setWidth(e.target.value)
  }

  function onQty(e: ChangeEvent<HTMLInputElement>) {
    setQty(e.target.value)
  }

  function clear() {
    setLength('')
    setWidth('')
    setQty('')
  }

  function goNext() {
    goNextStep(activeThickness, length, width, qty)
  }

  const goBack = useCallback(() => {
    goBackStep()
  }, [goBackStep])

  return (
    <div className="CS_Step3">
      <Steps step={3} allSteps={5} />
      {data.header && <Header text={data.header} />}

      {activeMaterial === 'Metal' && (
        <div className="CS_Step3-line">
          <div>
            {data.label && (
              <label className="CS_Step3-label">{data.label}</label>
            )}

            <div className="CS_Step3-radioContainer">
              <div
                className={`CS_Step3-radio ${
                  activeThickness === '3/16”' ? 'active' : ''
                } `}
                onClick={() => changeThickness('3/16”')}
                tabIndex={0}
              >
                3/16”
              </div>
              <div
                className={`CS_Step3-radio ${
                  activeThickness === '1/8”' ? 'active' : ''
                } `}
                onClick={() => changeThickness('1/8”')}
                tabIndex={0}
              >
                1/8”
              </div>
            </div>
          </div>

          <div className="CS_Step3-infoContainer">
            {data.size_3_16_info && (
              <p>
                <b>3/16”:</b> {data.size_3_16_info}
              </p>
            )}
            {data.size_1_8_info && (
              <p>
                <b>1/8”:</b> {data.size_1_8_info}
              </p>
            )}
          </div>
        </div>
      )}

      <div
        className={`CS_Step3-form ${
          activeMaterial === 'Wood' ? 'no-padding' : ''
        }`}
      >
        <div className="CS_Step3-item1">
          <p className="CS_Step3-formLabel">Inside Dimensions</p>
          <div className="CS_Step3-inputContainer">
            <input
              onChange={onLength}
              value={length}
              className="CS_Step3-input"
              placeholder="LENGTH"
            />
          </div>
        </div>

        <div className="CS_Step3-item1">
          <p
            className="CS_Step3-link desktop js-offcanvas-trigger"
            tabIndex={0}
            data-drawer-name="section"
          >
            How to Measure
          </p>
          <div className="CS_Step3-inputContainer">
            <input
              onChange={onWidth}
              value={width}
              className="CS_Step3-input"
              placeholder="WIDTH"
            />
          </div>
          <p
            tabIndex={0}
            className="CS_Step3-link mobile js-offcanvas-trigger"
            data-drawer-name="section"
          >
            How to Measure
          </p>
        </div>

        <div className="CS_Step3-qtyContainer">
          <p className="CS_Step3-formLabel">Quantity</p>
          <input
            onChange={onQty}
            value={qty}
            type="number"
            min="1"
            max="1000"
            className="CS_Step3-inputRange"
          />
        </div>

        <div className="CS_Step3-clearContainer">
          <span tabIndex={0} className="CS_Step3-clear" onClick={clear}>
            Clear Quantity
          </span>
        </div>
      </div>

      <div className="CS_Step3-btnContainer">
        <button className="GoBack" onClick={goBack}>
          <svg
            width="16"
            height="10"
            viewBox="0 0 16 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.75 5L1.25 5M1.25 5L5.54032 0.999999M1.25 5L5.54032 9"
              stroke="#4E6280"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Back
        </button>
        {showButton === true && (
          <button
            className="o-button o-button--blue CS_Step3-btn"
            onClick={goNext}
          >
            Next
          </button>
        )}
      </div>
    </div>
  )
}
